import React from "react"
import {useSelector} from "react-redux";
import {getDataFresh, getDepartmentsData} from "../../../state/selectors";
import { Box, Table, Title } from "@allxsmith/bestax-bulma";
import Spinner from "react-spinner-material";
import DepartmentRow from "./DepartmentRow";
import NewDepartment from "./NewDepartment";
import LoadingSpinner from "../../Utils/Spinner";




function DepartmentView(props){
    let dataFresh = useSelector(getDataFresh);


    let departments = useSelector(getDepartmentsData)

    if (!props.loading) {
        return (
            <LoadingSpinner/>
        );
    }


    return (
        <div>
            <br/>
            <NewDepartment/>
            <Box>
                <details>
                    <summary><Title>Departments</Title></summary>
                <Table>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Hide</th>
                            <th></th>
                        </tr>
                    </thead>
                    {departments.results.map(department => (
                        <DepartmentRow
                            department={department}
                            dataFresh={dataFresh}
                        />
                    ))}
                </Table>
                </details>
            </Box>
        </div>
    );
};
export default DepartmentView;